$(document).ready(function () {

    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-dropup-modal-target="#send-message"][data-ad-id]');
        if (!trigger) return;
        $('#SendMessageAdId').val(trigger.getAttribute('data-ad-id'));
    });

    function openDropupModal(selector, replace) {
        var trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.style.display = 'none';
        trigger.setAttribute('data-dropup-modal-target', selector);
        if (replace) {
            trigger.setAttribute('data-dropup-modal-replace', 'true');
        }
        document.body.appendChild(trigger);
        trigger.click();
        document.body.removeChild(trigger);
    }

    var messageResultText = window.pzSendMessage;

    function showMessageResult(isSuccess) {
        $('#message-result-clipart').toggle(isSuccess);
        $('#message-result-header').text(isSuccess
            ? messageResultText.successHeader
            : messageResultText.failedHeader);
        $('#message-result-description').text(isSuccess
            ? messageResultText.successDescription
            : messageResultText.failedDescription);
        openDropupModal('#message-sent', true);
    }

    $('#SendMessageVisitorName, #SendMessageVisitorEmail, #SendMessageVisitorPhone, #SendMessageText')
        .off('keypress.sendMessage').on('keypress.sendMessage', function () {
            $(this).parent().removeClass('has-error');
        });

    $('#send-message-submit').off('click.sendMessage').on('click.sendMessage', function (e) {
        e.preventDefault();

        var errorsCount = 0;
        $('#SendMessageVisitorName, #SendMessageVisitorEmail, #SendMessageText').each(function () {
            if ($(this).val() == "") {
                $(this).parent().addClass('has-error');
                errorsCount++;
            }
        });

        // Server requires at least 5 characters on the phone copies, so reject shorter input
        // here instead of letting it come back as a generic send failure.
        var phone = $('#SendMessageVisitorPhone').val();
        if (phone.replace(/ /g, '').length < 5) {
            $('#SendMessageVisitorPhone').parent().addClass('has-error');
            errorsCount++;
        }

        if (errorsCount > 0) return;

        var formData = {
            "VisitorName": $('#SendMessageVisitorName').val(),
            "VisitorEmail": $('#SendMessageVisitorEmail').val(),
            "MessageText": $('#SendMessageText').val(),
            "VisitorPhone": phone,
            "VisitorPhoneSecond": phone,
            "VisitorPhoneThird": phone,
            "SendToMe": $('#SendMessageSendToMe').is(":checked"),
            "Id": $('#SendMessageAdId').val()
        };

        var $submit = $(this);
        $submit.prop('disabled', true).addClass('active');

        $.ajax({
            url: window.pzSendMessage.url,
            data: JSON.stringify(formData),
            type: "post",
            contentType: "application/json",
            processData: false
        })
        .done(function () {
            $('#SendMessageText').val('');
            showMessageResult(true);
        })
        .fail(function () {
            showMessageResult(false);
        })
        .always(function () {
            $submit.prop('disabled', false).removeClass('active');
        });
    });

    if (window.pzSendMessage.hideCopyRow) {
        $('#send-message-copy-row').addClass('hide');
    }
});
